import { render, staticRenderFns } from "./DecorationSelect.vue?vue&type=template&id=54874ea1&scoped=true"
import script from "./DecorationSelect.vue?vue&type=script&lang=js"
export * from "./DecorationSelect.vue?vue&type=script&lang=js"
import style0 from "./DecorationSelect.vue?vue&type=style&index=0&id=54874ea1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54874ea1",
  null
  
)

export default component.exports